import sites from '@/components/sites/sites/storage'
import positions from '@/components/sites/positions/storage'
import yandexRegion from '@/components/sites/searchEngine/components/yandexRegion/storage'
import googleRegion from '@/components/sites/searchEngine/components/googleRegion/storage'
import statistic from '@/components/sites/statistic/general/storage'
import chartStatistic from '@/components/sites/statistic/chart/storage'
import indexing from '@/components/sites/indexing/storage'
import group from '@/components/sites/group/storage'
import groupPositions from '@/components/sites/groupPositions/storage'
import settings from '@/components/sites/settings/storage'

export default {
    namespaced: true,
    modules: {
        sites,
        positions,
        googleRegion,
        yandexRegion,
        statistic,
        chartStatistic,
        indexing,
        group,
        groupPositions,
        settings,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}